import React from "react";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ScatterChart,
  Scatter,
  ZAxis,
  Cell,
  ReferenceLine,
  LabelList,
} from "recharts";

const TestAnalysisDashboard = () => {
  // Data from analysis
  const data = {
    testScores: [
      {
        student: "S1",
        group: "Experimental",
        test1: 25,
        test2: 30,
        improvement: 5,
      },
      {
        student: "S2",
        group: "Experimental",
        test1: 39,
        test2: 40,
        improvement: 1,
      },
      {
        student: "S4",
        group: "Experimental",
        test1: 44,
        test2: 44,
        improvement: 0,
      },
      { student: "S5", group: "Control", test1: 37, test2: 37, improvement: 0 },
      { student: "S6", group: "Control", test1: 37, test2: 37, improvement: 0 },
      {
        student: "S7",
        group: "Experimental",
        test1: 47,
        test2: 47,
        improvement: 0,
      },
      { student: "S9", group: "Control", test1: 28, test2: 28, improvement: 0 },
      {
        student: "S12",
        group: "Experimental",
        test1: 45,
        test2: 45,
        improvement: 0,
      },
      {
        student: "S13",
        group: "Experimental",
        test1: 24,
        test2: 26,
        improvement: 2,
      },
      {
        student: "S15",
        group: "Control",
        test1: 36,
        test2: 36,
        improvement: 0,
      },
      {
        student: "S17",
        group: "Control",
        test1: 38,
        test2: 39,
        improvement: 1,
      },
      {
        student: "S18",
        group: "Control",
        test1: 32,
        test2: 32,
        improvement: 0,
      },
      {
        student: "S19",
        group: "Experimental",
        test1: 15,
        test2: 19,
        improvement: 4,
      },
      {
        student: "S20",
        group: "Control",
        test1: 42,
        test2: 42,
        improvement: 0,
      },
      {
        student: "S21",
        group: "Control",
        test1: 28,
        test2: 28,
        improvement: 0,
      },
      {
        student: "S22",
        group: "Experimental",
        test1: 40,
        test2: 40,
        improvement: 0,
      },
      {
        student: "S23",
        group: "Experimental",
        test1: 36,
        test2: 38,
        improvement: 2,
      },
      {
        student: "S26",
        group: "Experimental",
        test1: 39,
        test2: 39,
        improvement: 0,
      },
      {
        student: "S27",
        group: "Experimental",
        test1: 14,
        test2: 14,
        improvement: 0,
      },
      {
        student: "S28",
        group: "Experimental",
        test1: 41,
        test2: 41,
        improvement: 0,
      },
      {
        student: "S29",
        group: "Control",
        test1: 45,
        test2: 45,
        improvement: 0,
      },
      {
        student: "S30",
        group: "Experimental",
        test1: 40,
        test2: 41,
        improvement: 1,
      },
      {
        student: "S31",
        group: "Experimental",
        test1: 38,
        test2: 40,
        improvement: 2,
      },
      {
        student: "S33",
        group: "Experimental",
        test1: 44,
        test2: 45,
        improvement: 1,
      },
      {
        student: "S34",
        group: "Experimental",
        test1: 49,
        test2: 49,
        improvement: 0,
      },
      {
        student: "S39",
        group: "Experimental",
        test1: 42,
        test2: 42,
        improvement: 0,
      },
      {
        student: "S40",
        group: "Experimental",
        test1: 32,
        test2: 33,
        improvement: 1,
      },
      {
        student: "S43",
        group: "Control",
        test1: 29,
        test2: 29,
        improvement: 0,
      },
      {
        student: "S45",
        group: "Experimental",
        test1: 35,
        test2: 37,
        improvement: 2,
      },
      {
        student: "S46",
        group: "Control",
        test1: 32,
        test2: 31,
        improvement: -1,
      },
      {
        student: "S47",
        group: "Control",
        test1: 37,
        test2: 37,
        improvement: 0,
      },
      {
        student: "S48",
        group: "Control",
        test1: 43,
        test2: 43,
        improvement: 0,
      },
      {
        student: "S51",
        group: "Experimental",
        test1: 34,
        test2: 34,
        improvement: 0,
      },
      {
        student: "S55",
        group: "Experimental",
        test1: 30,
        test2: 29,
        improvement: -1,
      },
      {
        student: "S56",
        group: "Experimental",
        test1: 44,
        test2: 44,
        improvement: 0,
      },
      {
        student: "S58",
        group: "Control",
        test1: 20,
        test2: 18,
        improvement: -2,
      },
      {
        student: "S59",
        group: "Experimental",
        test1: 40,
        test2: 40,
        improvement: 0,
      },
      {
        student: "S60",
        group: "Control",
        test1: 40,
        test2: 40,
        improvement: 0,
      },
      {
        student: "S62",
        group: "Control",
        test1: 27,
        test2: 27,
        improvement: 0,
      },
      {
        student: "S63",
        group: "Control",
        test1: 10,
        test2: 12,
        improvement: 2,
      },
      {
        student: "S64",
        group: "Experimental",
        test1: 40,
        test2: 40,
        improvement: 0,
      },
      {
        student: "S65",
        group: "Experimental",
        test1: 33,
        test2: 36,
        improvement: 3,
      },
      {
        student: "S66",
        group: "Experimental",
        test1: 30,
        test2: 32,
        improvement: 2,
      },
      {
        student: "S67",
        group: "Control",
        test1: 36,
        test2: 36,
        improvement: 0,
      },
      {
        student: "S69",
        group: "Control",
        test1: 37,
        test2: 37,
        improvement: 0,
      },
      {
        student: "S71",
        group: "Experimental",
        test1: 38,
        test2: 39,
        improvement: 1,
      },
      {
        student: "S72",
        group: "Control",
        test1: 31,
        test2: 31,
        improvement: 0,
      },
      {
        student: "S73",
        group: "Experimental",
        test1: 36,
        test2: 35,
        improvement: -1,
      },
      {
        student: "S74",
        group: "Control",
        test1: 43,
        test2: 44,
        improvement: 1,
      },
      {
        student: "S75",
        group: "Control",
        test1: 41,
        test2: 41,
        improvement: 0,
      },
      {
        student: "S76",
        group: "Control",
        test1: 19,
        test2: 17,
        improvement: -2,
      },
      {
        student: "S77",
        group: "Control",
        test1: 34,
        test2: 34,
        improvement: 0,
      },
      {
        student: "S78",
        group: "Experimental",
        test1: 34,
        test2: 37,
        improvement: 3,
      },
      {
        student: "S80",
        group: "Control",
        test1: 40,
        test2: 41,
        improvement: 1,
      },
      {
        student: "S82",
        group: "Control",
        test1: 40,
        test2: 41,
        improvement: 1,
      },
      {
        student: "S83",
        group: "Control",
        test1: 40,
        test2: 41,
        improvement: 1,
      },
      {
        student: "S85",
        group: "Control",
        test1: 40,
        test2: 40,
        improvement: 0,
      },
      {
        student: "S86",
        group: "Control",
        test1: 33,
        test2: 34,
        improvement: 1,
      },
      {
        student: "S87",
        group: "Control",
        test1: 41,
        test2: 41,
        improvement: 0,
      },
      {
        student: "S88",
        group: "Experimental",
        test1: 41,
        test2: 41,
        improvement: 0,
      },
    ],
    groupMeans: [
      {
        group: "Experimental",
        test1Mean: 36.3,
        test2Mean: 37.23,
        improvementMean: 0.93,
      },
      {
        group: "Control",
        test1Mean: 34.53,
        test2Mean: 34.63,
        improvementMean: 0.1,
      },
    ],
    bandImprovements: [
      {
        group: "Experimental",
        band1: 0.2,
        band2: 0.37,
        band3: 0.2,
        band4: 0.17,
        band5: 0,
      },
      {
        group: "Control",
        band1: 0.03,
        band2: 0.1,
        band3: 0.03,
        band4: 0,
        band5: -0.07,
      },
    ],
    backgroundCorrelations: [
      { variable: "Books", correlation: 0.053 },
      { variable: "Movies", correlation: 0.245 },
      { variable: "SocialMedia", correlation: -0.105 },
      { variable: "SchoolingYears", correlation: -0.001 },
    ],
  };

  // Prepare data for score distribution
  const experimentalScores = data.testScores.filter(
    (s) => s.group === "Experimental"
  );
  const controlScores = data.testScores.filter((s) => s.group === "Control");

  // Calculate improvement distribution for the histogram
  const getImprovementCounts = (scores) => {
    const improvements = [-2, -1, 0, 1, 2, 3, 4, 5];
    return improvements.map((imp) => ({
      value: imp,
      Experimental: scores.filter(
        (s) => s.group === "Experimental" && s.improvement === imp
      ).length,
      Control: scores.filter(
        (s) => s.group === "Control" && s.improvement === imp
      ).length,
    }));
  };

  const improvementDistribution = getImprovementCounts(data.testScores);

  // Format band data for the chart
  const bandData = [
    {
      name: "Band 1",
      Experimental: data.bandImprovements[0].band1,
      Control: data.bandImprovements[1].band1,
    },
    {
      name: "Band 2",
      Experimental: data.bandImprovements[0].band2,
      Control: data.bandImprovements[1].band2,
    },
    {
      name: "Band 3",
      Experimental: data.bandImprovements[0].band3,
      Control: data.bandImprovements[1].band3,
    },
    {
      name: "Band 4",
      Experimental: data.bandImprovements[0].band4,
      Control: data.bandImprovements[1].band4,
    },
    {
      name: "Band 5",
      Experimental: data.bandImprovements[0].band5,
      Control: data.bandImprovements[1].band5,
    },
  ];

  // Format correlations for the chart
  const correlationData = data.backgroundCorrelations.map((item) => ({
    name: item.variable,
    correlation: item.correlation,
  }));

  // Styles to replace Tailwind classes
  const styles = {
    container: {
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "32px",
      backgroundColor: "#f9fafb",
      fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    },
    card: {
      backgroundColor: "white",
      boxShadow: "0 4px 6px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.06)",
      borderRadius: "10px",
      padding: "28px",
    },
    title: {
      fontSize: "28px",
      fontWeight: "bold",
      marginBottom: "24px",
      color: "#1f2937",
      letterSpacing: "-0.5px",
      fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    },
    sectionTitle: {
      fontSize: "20px",
      fontWeight: "600",
      marginBottom: "16px",
      color: "#374151",
      letterSpacing: "-0.3px",
      fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    },
    chartContainer: {
      height: "320px",
      marginBottom: "8px",
    },
    sectionContainer: {
      marginBottom: "36px",
    },
    caption: {
      fontSize: "14px",
      color: "#6b7280",
      marginTop: "10px",
      lineHeight: "1.5",
      fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Test Performance Analysis</h1>

        <div style={styles.sectionContainer}>
          <h2 style={styles.sectionTitle}>Mean Test Scores by Group</h2>
          <div style={styles.chartContainer}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={data.groupMeans}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="group" />
                <YAxis domain={[0, 50]} />
                <Tooltip />
                <Legend />
                <Bar name="Test 1 Score" dataKey="test1Mean" fill="#8884d8" />
                <Bar name="Test 2 Score" dataKey="test2Mean" fill="#82ca9d" />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <p style={styles.caption}>
            The experimental group showed higher mean scores in both tests, with
            a larger improvement from Test 1 to Test 2.
          </p>
        </div>

        <div style={styles.sectionContainer}>
          <h2 style={styles.sectionTitle}>Average Improvement by Group</h2>
          <div style={styles.chartContainer}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={data.groupMeans}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="group" />
                <YAxis domain={[0, 1.5]} />
                <Tooltip />
                <Legend />
                <Bar
                  name="Mean Score Improvement"
                  dataKey="improvementMean"
                  fill="#ff7300"
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <p style={styles.caption}>
            The experimental group showed significantly higher average
            improvement (0.93 points) compared to the control group (0.1
            points).
          </p>
        </div>

        <div style={styles.sectionContainer}>
          <h2 style={styles.sectionTitle}>
            Distribution of Score Improvements
          </h2>
          <div style={styles.chartContainer}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={improvementDistribution}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="value"
                  label={{
                    value: "Score Improvement",
                    position: "insideBottom",
                    offset: -5,
                  }}
                />
                <YAxis
                  label={{
                    value: "Number of Students",
                    angle: -90,
                    position: "insideLeft",
                  }}
                />
                <Tooltip />
                <Legend />
                <Bar
                  name="Experimental"
                  dataKey="Experimental"
                  fill="#8884d8"
                />
                <Bar name="Control" dataKey="Control" fill="#82ca9d" />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <p style={styles.caption}>
            More students in the experimental group showed positive
            improvements, while the control group mostly maintained the same
            scores.
          </p>
        </div>

        <div style={styles.sectionContainer}>
          <h2 style={styles.sectionTitle}>Improvement by Band</h2>
          <div style={styles.chartContainer}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={bandData}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar
                  name="Experimental"
                  dataKey="Experimental"
                  fill="#8884d8"
                />
                <Bar name="Control" dataKey="Control" fill="#82ca9d" />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <p style={styles.caption}>
            The experimental group showed the most improvement in Band 2, while
            the control group showed minimal or no improvement across all bands.
          </p>
        </div>

        <div style={styles.sectionContainer}>
          <h2 style={styles.sectionTitle}>
            Correlation of Background Variables with Improvement
          </h2>
          <div style={styles.chartContainer}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={correlationData}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                layout="vertical"
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" domain={[-0.3, 0.3]} />
                <YAxis dataKey="name" type="category" />
                <Tooltip />
                <Legend />
                <Bar
                  name="Correlation with Score Improvement"
                  dataKey="correlation"
                  fill="#8884d8"
                >
                  {correlationData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={entry.correlation >= 0 ? "#82ca9d" : "#ff7300"}
                    />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
          <p style={styles.caption}>
            Movie watching habits showed the strongest positive correlation with
            improvement, while social media usage had a slight negative
            correlation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TestAnalysisDashboard;
